<template>
  <div class="footer-content container-fluid">
    <div class="footer-group">
      <a class="logo" href="/src/vue/pages/public">
        <img alt="logo-footer" src="../../../../assets/img/logo-marq.png"/>
      </a>
      <a class="arrow-up" v-on:click="scrollTop()">
        <ion-icon name="arrow-up-circle-outline"></ion-icon>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "footer-menu",
  data() {
    return {};
  },
  methods: {
    scrollTop() {
      $('html,body').animate({scrollTop: $('body').offset().top - 80}, 'slow');
    }
  },
};
</script>

<style lang="scss" scoped>

.footer-content {
  margin-top: 60px;
  border-top: 1px solid #c9c9c9;

  .footer-group {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 20px 0;
    background: #E6E9EC;

    .logo {
      img {
        width: 216px;
      }
    }

    .arrow-up {
      height: 50px;
      text-decoration: none;

      ion-icon {
        color: var(--dark-gray);
        font-size: 50px;

        &:hover {
          color: #2c323b;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/footerMenu.vue